/**
 * Игрок, чья покупка ФРАКЦИОННОГО СКИНА ОТРЯДОВ решает, каким будет показан
 * этот отряд — и на поле (HexGridRenderer.renderUnit), и в интерфейсе
 * (UnitIcon через getUnitIconDisplayProps).
 *
 * Ищется по ID ИСХОДНОГО владельца (unit.capturedFromOwnerId ?? unit.ownerId),
 * а НЕ по совпадению фракции. Совпадение фракции ломается, когда за одну
 * фракцию в матче играют несколько игроков — сервер уникальность фракции в
 * лобби не проверяет (SELECT_FACTION), и такие партии реальны. Поиск первого
 * игрока нужной фракции отдавал чужой ответ: игрок с купленным скином видел
 * свои отряды стандартными силуэтами, если игрок той же фракции БЕЗ покупки
 * стоял в массиве players раньше (жалоба по крысолюдам), и наоборот — игрок
 * без покупки мог получить чужой скин.
 *
 * Фракция всё равно сверяется с найденным игроком: скин привязан к фракции
 * ОТРЯДА, а у соблазнённого Суккубом отряда предыдущий владелец мог сам быть
 * захватчиком (повторный захват затирает capturedFromOwnerId прошлым
 * владельцем, а не первым), и тогда связь с исходным игроком потеряна. В
 * таком случае игрок берётся по фракции, только если он ЕДИНСТВЕННЫЙ:
 * неоднозначность трактуется в пользу «скина нет», чтобы никогда не показать
 * скин, которого игрок не покупал.
 *
 * @param {Object} params
 * @param {string|null} params.factionId - фракция ОТРЯДА (не текущего владельца)
 * @param {string|null} params.originalOwnerId - ID исходного владельца отряда
 * @param {Array} players - все игроки партии
 * @returns {Object|null} игрок, чей hasUnitSkin решает вид отряда
 */
export const findUnitSkinOwnerPlayer = ({factionId, originalOwnerId}, players) => {
  if (!factionId || !Array.isArray(players)) {
    return null;
  }

  const playerByOrigin = originalOwnerId != null
    ? players.find((player) => player.id === originalOwnerId)
    : null;
  if (playerByOrigin && playerByOrigin.factionId === factionId) {
    return playerByOrigin;
  }

  const factionPlayers = players.filter((player) => player.factionId === factionId);
  return factionPlayers.length === 1 ? factionPlayers[0] : null;
};
